import { useMemo, useState } from "react";
import UnitedTerms, { UnitedTermsPropType } from "../Register/United/UnitedTerms";
import { Box, Typography, Unstable_Grid2 as Grid } from "@mui/material";
import { LoadingButton } from "@/components/common/LoadingButton";
import { toast } from "react-toastify";
import makeErrorString from "@/utils/makeErrorString";
import { postConfirmTerms } from "@/services/auth.service";
import { useNavigate, useParams } from "react-router-dom";
import { checkSpaceIsOpened } from "@/services/studio.service";
import { requestOpenMallV2 } from "@/services/open-mall.service";

export default function ConfirmTerms() {
    const { userId = '' } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [isAgreePolicy, setIsAgreePolicy] = useState(false);
    const [agreePolicy, setAgreePolicy] = useState(false);
    const [agreeSalesRules, setAgreeSalesRules] = useState(false);
    const [agreePrivateRules, setAgreePrivateRules] = useState(false);
    const [isAdult, setIsAdult] = useState(false);
    const [agreeMarketing, setAgreeMarketing] = useState(false);
    const isAllAgree = useMemo(() => {
        return (isAgreePolicy && agreePolicy && agreeSalesRules && agreePrivateRules && isAdult);
    }, [agreePolicy, agreeSalesRules, agreePrivateRules, isAdult, isAgreePolicy])

    const handleAllAgree = (checked: boolean) => {
        try {
            setIsAgreePolicy(checked);
            setAgreePolicy(checked);
            setAgreeSalesRules(checked);
            setAgreePrivateRules(checked);
            setIsAdult(checked);
            setAgreeMarketing(checked);
        } catch (e) {
            console.error(e);
        }
    }
    const unitedTermsProp: UnitedTermsPropType = {
        handleAllAgree,
        isAllAgree,
        setState: {
            setIsAgreePolicy,
            setAgreePolicy,
            setAgreePrivateRules,
            setAgreeSalesRules,
            setIsAdult,
            setAgreeMarketing
        },
        stateValue: {
            isAgreePolicy,
            agreePolicy,
            agreePrivateRules,
            agreeSalesRules,
            isAdult,
            agreeMarketing
        }
    }
    return (
        <Box className="flex flex-col" sx={{ gap: 10 }}>
            <Box
                className="flex w-full flex-col justify-center items-center"
                sx={{
                    width: '100%',
                }}
            >
                <Grid container className="w-full" sx={{ my: 1 }}>
                    <Typography component={'p'} variant={'body'}>
                        플로잉 스페이스 개설을 하기 위한 플로잉 서비스 및 상점 관련 약관에 동의해주세요.
                    </Typography>
                </Grid>
                <Grid container>
                    <Grid xs={12}>
                        <UnitedTerms {...unitedTermsProp} />
                    </Grid>
                </Grid>
            </Box>
            <LoadingButton
                isLoading={!!loading}
                variant="contained"
                size="large"
                fullWidth
                disabled={!(isAgreePolicy && agreePolicy && agreeSalesRules && agreePrivateRules && isAdult)}
                onClick={async () => {
                    setLoading(true)
                    try {
                        const check = await checkSpaceIsOpened(userId).catch((error) => {
                            console.log(error)
                            return {}
                        })
                        console.log('check::::', check)
                        if (!!check?.isNotOpened) {
                            await postConfirmTerms(
                                userId,
                                {
                                    emailMarketingConsented: agreeMarketing,
                                    smsMarketingConsented: agreeMarketing
                                }
                            )
                        } else {
                            await requestOpenMallV2({
                                smsMarketingConsented: agreeMarketing,
                                emailMarketingConsented: agreeMarketing
                            })
                        }
                        navigate('/')
                    } catch (error) {
                        toast.error(makeErrorString(error), { toastId: 'reject-start' })
                        throw error
                    } finally {
                        setLoading(false)
                    }
                }}
            >시작하기</LoadingButton>
        </Box>
    )
}